import { render, staticRenderFns } from "./pengembangan_ekonomi.vue?vue&type=template&id=2c78f0c7"
import script from "./pengembangan_ekonomi.vue?vue&type=script&lang=js"
export * from "./pengembangan_ekonomi.vue?vue&type=script&lang=js"
import style0 from "./pengembangan_ekonomi.vue?vue&type=style&index=0&id=2c78f0c7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports